/**
 * Storage keys for per-plan UI state that should survive navigating away to
 * another plan and back (`PlanDetailsProvider` remounts per plan id, which
 * would otherwise reset any in-memory selection). Pair with `usePersistedState`.
 * Add a new entry here for each additional feature that needs this — e.g.
 * filters, expanded rows, selected columns.
 */
export const planUiStateKeys = {
    showOptimizedView: (planId: string | undefined) =>
        planId ? `tpoGen:plan:${planId}:showOptimizedView` : null,
};
